export type WidgetSize = 'small' | 'medium' | 'large';
export type WidgetSizeDimensions = {
  width: string;
  maxHeight: string;
};

export const WIDGET_SIZE_PRESETS: Record<WidgetSize, WidgetSizeDimensions> = {
  small: {
    width: '380px',
    maxHeight: '760px',
  },
  medium: {
    width: '534px',
    maxHeight: '850px',
  },
  large: {
    width: '668px',
    maxHeight: 'calc(100% - 32px)',
  },
};

export const getViewportConstrainedMaxHeight = (size: WidgetSize, marginPx = 32): string => {
  const sizePreset = WIDGET_SIZE_PRESETS[size];

  if (size === 'large') {
    return `calc(100% - ${marginPx}px)`;
  }

  const viewportConstrainedHeight = `calc(100% - ${marginPx}px)`;
  return `min(${sizePreset.maxHeight}, ${viewportConstrainedHeight})`;
};
